const max_screen = 1920,
jagger           = {
	DEFAULT: "#3F0C5D",
		50: "#A63BE6",
		100: "#9E29E3",
		200: "#881AC9",
		300: "#7015A5",
		400: "#571181",
		500: "#3F0C5D",
		600: "#1D062B",
		700: "#000000",
		800: "#000000",
		900: "#000000",
		950: "#000000",
		},
		neon_carrot = {
			DEFAULT: "#FF972E",
				50: "#FFF2E6",
				100: "#FFE8D1",
				200: "#FFD4A8",
				300: "#FFC080",
				400: "#FFAB57",
				500: "#FF972E",
				600: "#F57B00",
				700: "#BD5F00",
				800: "#854300",
				900: "#4D2600",
				950: "#311800",
				hover: "#FE5C4D",
				};

				export default {
					extend: {
						page: {
							gap: {
								0: "2rem",
								xl: "4rem",
							},
							mt: {
								0: "2.125rem",
								xl: "1.75rem",
							},
						},
						transitionDuration: {
							DEFAULT: "500ms",
								},
								fontFamily: {
									nunito: ["nunito", "sans-serif"],
								},
								fontData: {
									nunito: {
										typoAscent: 1011,
										typoDescent: -353,
										capitalHeight: 705,
										emSize: 1000,
									},
								},
								elements: {
									a: "safe-transition cursor-pointer",
									input: "safe-transition cursor-pointer",
									label: "safe-transition cursor-pointer",
									button: "safe-transition cursor-pointer",
								},
								screens: {
									0: "0px",
									xs: "375px",
									"after-xs": "376px",
									max: `${max_screen}px`,
								},
								container: {
									center: true,
									maxWidth: {
										0: "80%",
										max: `${max_screen * 0.8}px`,
									},
								},
								colors: {
									transparent: "transparent",
									current: "currentColor",
									"body-background": "#ffffff",
									black: "#000000",
									white: "#ffffff",
									primary: jagger,
									secondary: neon_carrot,
									jagger,
									neon_carrot,
								},
								header: {
									height: {
										0: 45 + 22 * 2,
										xl: 30 + 52 * 2,
									},
								},
								animation: {
									float: "float 8s ease infinite",
								},
								keyframes: {
									float: {
										"0%, 100%": {
											transform: "translateY(-15px)",
										},
										"50%": {
											transform: "none",
										},
									},
								},
								},
								};
